export function Footer() {
  return (
    <footer className="border-t border-border-subtle py-10">
      <div className="container-page flex flex-col items-start justify-between gap-4 text-[13.5px] text-ink-faint sm:flex-row sm:items-center">
        <span>Claros — business health, decided.</span>
        <span>© {new Date().getFullYear()} Claros · claros.pro</span>
      </div>
    </footer>
  );
}
